prodproApp.filter('trustHtml', ['$sce', function($sce) {

    return function(htmlCode) {
        return $sce.trustAsHtml(htmlCode);
    }

}]);